import { useEffect } from "react";
import { seo, urlFor, buildSchema } from "../seo/schema";

const SITE_URL = process.env.REACT_APP_SITE_URL;

const upsert = (tag, key, keyVal, attrs) => {
  let el = document.head.querySelector(`${tag}[${key}="${keyVal}"]`);
  if (!el) {
    el = document.createElement(tag);
    el.setAttribute(key, keyVal);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

export const useSeo = (rawPath) => {
  const path = rawPath.length > 1 ? rawPath.replace(/\/+$/, "") : rawPath;
  useEffect(() => {
    const p = seo.pages[path];
    if (!p) return;
    const url = urlFor(SITE_URL, path);
    const img = `${SITE_URL}${p.ogImage || p.image}`;
    document.head.querySelector('meta[name="robots"]')?.remove();
    document.title = p.title;
    upsert("meta", "name", "description", { content: p.description });
    upsert("link", "rel", "canonical", { href: url });
    upsert("meta", "property", "og:title", { content: p.title });
    upsert("meta", "property", "og:description", { content: p.description });
    upsert("meta", "property", "og:type", { content: p.ogType || "website" });
    upsert("meta", "property", "og:url", { content: url });
    upsert("meta", "property", "og:image", { content: img });
    upsert("meta", "property", "og:site_name", { content: seo.siteName });
    upsert("meta", "name", "twitter:card", { content: "summary_large_image" });
    upsert("meta", "name", "twitter:title", { content: p.title });
    upsert("meta", "name", "twitter:description", { content: p.description });
    upsert("meta", "name", "twitter:image", { content: img });
    let ld = document.getElementById("hh-jsonld");
    if (!ld) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.id = "hh-jsonld";
      document.head.appendChild(ld);
    }
    ld.textContent = JSON.stringify(buildSchema(path, SITE_URL));
  }, [path]);
};
